import { gql } from 'apollo-boost';

export const serviceCollectionsQuery = gql`
{
  allServiceCollections {
    edges {
      node {
        dbId
        name
        description
        version
      }
    }
  }
}
`;
